'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaStarHalfEmpty = function FaStarHalfEmpty(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28 21.4l5.7-5.6-9.4-1.4-0.7-1.3-3.5-7.2v21.5l1.3 0.7 7.1 3.7-1.4-7.9-0.2-1.5z m10.1-5.9l-8.1 7.9 1.9 11.2q0.1 0.7-0.2 1.1t-0.7 0.4q-0.4 0-0.9-0.2l-10-5.3-10 5.3q-0.6 0.2-0.9 0.2-0.6 0-0.8-0.4t-0.1-1.1l1.9-11.2-8.1-7.9q-0.8-0.7-0.6-1.3t1.3-0.8l11.2-1.6 5-10.2q0.4-0.9 1.1-0.9 0.6 0 1.1 0.9l5 10.2 11.2 1.6q1 0.2 1.2 0.8t-0.5 1.3z' })
        )
    );
};

exports.default = FaStarHalfEmpty;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/star-half-empty.js
// module id = 1658
// module chunks = 0